/**
 * Organisation-wide Behavioral questions (0111). A super admin switches them on once in Profile →
 * Interview settings and every AI interview plan the org generates afterwards — the requirement's
 * shared plan and each candidate's resume-tailored plan — carries them right after the opener.
 * No need to add them requirement by requirement.
 *
 * Off by default (null on the org row). On with no questions of their own → the defaults below.
 * Like every other question, a behavioral answer is judged on its CONTENT only (GROUND_RULES):
 * never on tone, accent or personality.
 */
import { z } from "zod";
export const MAX_BEHAVIORAL_QUESTIONS = 5;
/** Used when the setting is on but the org hasn't written its own. Situation-based, role-neutral. */
export const DEFAULT_BEHAVIORAL_QUESTIONS = [
    "Tell me about a time you disagreed with a teammate or manager about how to approach a piece of work. What did you do, and how did it turn out?",
    "Describe a situation where you had to deliver under a tight deadline. How did you decide what to prioritise, and what was the result?",
];
export const behavioralSettingSchema = z.object({
    enabled: z.boolean(),
    questions: z.array(z.string().trim().min(4).max(1000)).max(MAX_BEHAVIORAL_QUESTIONS),
});
/** What a stored (possibly null / malformed) org value means. */
export function readBehavioralSetting(raw) {
    const parsed = behavioralSettingSchema.safeParse(raw);
    return parsed.success ? parsed.data : { enabled: false, questions: [] };
}
/** The behavioral questions an interview plan must carry — empty when the setting is off. */
export function behavioralQuestionsInForce(raw) {
    const s = readBehavioralSetting(raw);
    if (!s.enabled)
        return [];
    const own = s.questions.map((q) => q.trim()).filter((q) => q.length >= 4);
    return own.length > 0 ? own : [...DEFAULT_BEHAVIORAL_QUESTIONS];
}
//# sourceMappingURL=behavioralQuestions.js.map